module.exports = __webpack_public_path__ + "static/media/chaudfontaine-rood.35e249de.jpg";